import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {durationToString} from '../../../../services/DurationUtil';
import Checkbox from './Checkbox';
import PriceTag from '../../../../components/common/pricetag/PriceTag';


class ValueServicesFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {customerPreJourneyInfo:{preJourneyInfo}} = this.props;

    return <React.Fragment>
      <div style={{ paddingLeft: 20 }}>
      <ul className="list">
      {preJourneyInfo.services.cart.items.map(item=>{
        return <li key={item.referenceId}>
          <Checkbox checked={true} disabled={true}>
            <span>{item.name}</span>
            <span style={{float:'right'}}>
              <PriceTag price={item.price}/>&nbsp;{item.duration ? `${durationToString(`PT${item.duration}M`)}` : ''}{' '}
            </span>
          </Checkbox>
        </li>
      })}
      </ul>
      </div>
    </React.Fragment>
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  customerPreJourneyInfo: state.customerPreJourneyInfo,
  publicContext: state.publicContext
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValueServicesFragment)
);
